import React from "react";
import styled from "styled-components";
import img1 from "../images/car1.jpeg";
import img2 from "../images/car2.webp";
import noblepro from "../images/car4.avif";
import bkgroundimg from "../images/car3.avif";
import { AiOutlineSafety } from "react-icons/ai";
import { PiVanBold } from "react-icons/pi";
import { MdAttachMoney } from "react-icons/md";
import { MdLocalConvenienceStore } from "react-icons/md";

function AutoMotives() {
  return (
    <AutoMotivesCon>
      <div className="bkgpic_msg">
        <div className="message">Automative Shipping</div>
      </div>
      <a className="globalhome" href="/">
        Global Home{" "}
      </a>
      | AutoMotives
      <div className="imgandesc">
        <div className="image-container">
          <img className="image" src={img1} alt=" " />
        </div>
        <div className="desc-container">
          The automotive supply chain is a complex and dynamic network that
          involves the coordination of various processes and entities to ensure
          the efficient production and delivery of vehicles. This intricate
          system encompasses multiple tiers of suppliers, manufacturers, and
          distributors, each playing a critical role in the seamless flow of
          materials and components. At the core of the automotive supply chain
          are the original equipment manufacturers (OEMs), which design and
          assemble vehicles. They rely heavily on a vast network of suppliers
          that provide the necessary parts and raw materials. These suppliers
          are categorized into different tiers based on their proximity to the
          OEMs. Tier 1 suppliers are direct suppliers to the OEMs, delivering
          essential components such as engines, transmissions, and electronics.
          Tier 2 and Tier 3 suppliers, on the other hand, supply parts and
          materials to the Tier 1 suppliers. One of the significant challenges
          in the automotive supply chain is maintaining just-in-time (JIT)
          delivery, a strategy that minimizes inventory costs by receiving goods
          only as they are needed in the production process. While JIT improves
          efficiency and reduces waste, it also makes the supply chain highly
          susceptible to disruptions. Natural disasters, geopolitical issues,
          and pandemics can all cause significant delays and shortages,
          affecting production timelines and costs.
        </div>

        <div className="desc-container">
          Technological advancements have been instrumental in enhancing supply
          chain visibility and efficiency. The integration of advanced data
          analytics, artificial intelligence, and the Internet of Things (IoT)
          enables real-time tracking and monitoring of shipments, predictive
          maintenance, and demand forecasting. These innovations help mitigate
          risks, optimize inventory management, and improve overall
          responsiveness to market changes.
          <br />
          <br />
          <p>
            Our logistics services ensure that packages are handled with the
            highest standards of security and compliance. We are proud to hold
            several key certifications that guarantee the safety and efficiency
            of our operations
            <br />
            <br />
            Sustainability is another critical aspect shaping the automotive
            supply chain. With increasing environmental regulations and consumer
            demand for eco-friendly vehicles, manufacturers and suppliers are
            adopting greener practices. This includes sourcing sustainable
            materials, reducing emissions throughout the supply chain, and
            implementing circular economy principles to recycle and reuse
            materials. In conclusion, the automotive supply chain is a
            multifaceted ecosystem that requires meticulous coordination and
            advanced technological integration to function efficiently. Despite
            its challenges, continuous improvements in technology and a growing
            focus on sustainability are driving the industry toward a more
            resilient and environmentally responsible future.
          </p>
        </div>
        <div className="image-container">
          <img className="image" src={img2} alt=" " />
        </div>
      </div>
      <div className="noblepro">
        <div className="messagepro">
          <h3>Every component matters</h3>
          <p>
            Tens of thousands of components – big and small – go into the marvel
            that is an automobile. This means that all the parts need to be in
            the right place at the right time. Delays are not acceptable as they
            risk slowing down the assembly line.
          </p>
          <br />
          <button>
            <a href="/GetaQuoteCon">SHIP WITH INTEGRAL</a>
          </button>
        </div>
      </div>
      <br />
      <h2>Why do you need Cars in Containers?</h2>
      <div className="Carconreasons">
        {ReaCarInCon.map((reacarincon, index) => (
          <div className="Res">
            <div className="">
              <div>{reacarincon.Ricon}</div>
              <br />
              <div className="Reason">
                <p>{reacarincon.Reason}</p>
              </div>
            </div>
            <br />

            <div className="Answers">
              <ul>
                {reacarincon.Details.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <p>{reacarincon.Answer}</p>
            </div>
          </div>
        ))}
      </div>
    </AutoMotivesCon>
  );
}

export default AutoMotives;

export const ReaCarInCon = [
  {
    Ricon: <AiOutlineSafety className="ricon" />,
    Reason: "Protection and Safety:",
    Details: [
      "Weather Protection: Containers shield vehicles from adverse weather conditions, such as rain, snow, and saltwater, which can cause damage or corrosion during transit.",
      "Physical Damage: Enclosed containers protect cars from physical damage, such as scratches, dents, and impacts that might occur during loading, unloading, or transportation.",
      "Theft and Vandalism: Containers provide a secure environment that helps prevent theft and vandalism, ensuring that vehicles arrive at their destination in the same condition they were shipped.",
    ],
  },
  {
    Ricon: <MdLocalConvenienceStore className="ricon" />,
    Reason: "Efficiency and Convenience",
    Details: [
      "Ease of Handling: Containers streamline the loading and unloading process, as they can be easily moved using cranes and forklifts, reducing the risk of damage during these operations.",
      "Consolidation: Multiple vehicles can be shipped in a single container, maximizing space utilization and reducing shipping costs. This is particularly beneficial for dealerships and manufacturers transporting multiple cars at once.",
    ],
  },

  {
    Ricon: <PiVanBold className="ricon" />,
    Reason: "Logistical Flexibility",
    Details: [
      "Intermodal Transport: Containers facilitate intermodal transport, allowing vehicles to be seamlessly transferred between ships, trains, and trucks without unloading and reloading, which saves time and reduces handling risks.",
      "Global Reach: Containers are compatible with international shipping standards, enabling cars to be transported to virtually any destination worldwide with ease.",
    ],
  },

  {
    Ricon: <MdAttachMoney className="ricon" />,
    Reason: "Cost-Effectiveness",
    Details: [
      "Reduced Insurance Costs: The added protection provided by containers can lead to lower insurance premiums, as the risk of damage or theft is minimized.",
      "Economies of Scale: Shipping multiple vehicles in one container can lower the cost per unit, making it a more economical choice for bulk shipments.",
    ],
  },
];

const AutoMotivesCon = styled.div`
  width: 75vw;
  margin-left: calc((100vw - 75vw) / 2);
  margin-right: calc((100vw - 75vw) / 2);

  .Carconreasons {
    with: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /*  grid-auto-rows: 100px 300px; */
    gap: 30px;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 50px;
    background: #fafafa;
  }

  .ricon {
    font-size: 35px;
  }
  .Reason {
    font-weight: bold;
  }
  .Res {
    border-radius: 5px;
    /*     border-radius: 00px 50px 0px 00px; */
  }

  .bkgpic_msg {
    background-image: url(${bkgroundimg});
    background-repeat: no-repeat;
    background-position: center; /* Center the background image */
    background-size: cover; /* Ensure the image covers the entire div */
    height: 30vh;
    display: flex; /* Use flexbox to center the text inside */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: relative; /* Allow positioning of text elements over the image */
  }

  .message {
    font-weight: bold;
    color: orangered;

    font-size: 24px;
  }
  .globalhome {
    padding-bottom: 20px;
  }

  .imgandesc {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-content: center;
    margin-top: 50px;
    gap: 30px;
  }
  .image-container .image {
    width: 35vw;
    height: 40vh;
  }

  .imgandesc .desc-container {
    padding: 20px;

    text-align: justify;
  }

  .noblepro {
    background: url(${noblepro});

    background-repeat: no-repeat;
    background-position: center; /* Center the background image */
    background-size: cover; /* Ensure the image covers the entire div */
    height: 65vh;
    display: flex; /* Use flexbox to center the text inside */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: relative; /* Allow positioning of text elements over the image */
  }
  .messagepro {
    background: gainsboro;
    border-radius: 0px 100px 100px 0px;
    position: relative;
    width: 50%;
    font-weight: bold;
    padding: 10px;
    text-align: left;
  }

  .messagepro:hover {
    background: #fffdd0;
  }

  button {
    position: relative;
    bottom: 0px;
    background: white;

    cursor: pointer;
    padding: 12px;
    border-radius: 15px;
  }
  button:hover {
    background: #023e7d;
    color: white;
  }

  @media (max-width: 700px) {
    width: 100vw;

    .imgandesc {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      justify-content: center;
      margin-top: 50px;
      gap: 30px;
      margin-left: -85px;
      padding-left: 5px;
      padding-right: 15px;
    }
    .image-container .image {
      width: 100vw;
      height: 30vh;
      justify-content: center;
      align-items: center;
      border-radius: 0px 200px 200px 0px;
    }
    .desc-containe {
      width: 100%;
    }
    .bkgpic_msg {
      margin-left: -65px;
    }
  }
`;
